export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/navigation-pointer.02be304c.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};